module.exports = __webpack_public_path__ + "static/media/YM35_0.d5429d7a.jpg";